import type { ReactNode } from 'react';

import { Container } from 'src/components/Container/Container';

import styles from './styles.module.scss';

type HeaderProps = {
  children: ReactNode;
};

export const Header = ({ children }: HeaderProps) => (
  <header className={styles.header}>
    <Container>{children}</Container>
  </header>
);
